export enum ConsentModalEvent {
  CloseModal = 'close-modal'
}
